import React, {useRef, useState} from 'react';
import View from './view';
import {Props} from './model';
import {change} from 'redux-form';
import {Forms} from '../../../../../../../shared/models/forms';
import {useDispatch} from 'react-redux';

export const Field = (props: Props) => {
  const dispatch = useDispatch();
  const prevValue = useRef(props.value);
  const [isChanging, setIsChanging] = useState(props.isChanging ?? false);

  const onTurnChanging = () => {
    if (!props.editable) return;
    prevValue.current = props.value;
    setIsChanging(true);
  };
  const onAccept = () => {
    setIsChanging(() => {
      props.setSubmissionErrors((prev: any) => ({...prev, [props.name]: null}));
      return false;
    });
  };
  const onDecline = () => {
    dispatch(change(Forms.esiaRegCardForm, props.name, prevValue.current));
    setIsChanging(false);
  };

  return (
    <View
      {...props}
      isChanging={isChanging}
      onTurnChanging={onTurnChanging}
      onDecline={onDecline}
      onAccept={onAccept}
    />
  );
};
